"use client";

import React, { ComponentType } from "react";
import styled from "styled-components";

import {
  Carousel as CarouselBase,
  IProps as ICarouselProps,
} from "@faire/retailer/components/Carousel/Carousel";

import { ITestimonial } from "../TestimonialContent";

type Props = {
  name: string;
  items: ITestimonial[];
  testimonialTiles: React.ReactNode[];
};

export const TestimonialTilesCarousel: React.FC<Props> = ({
  name,
  testimonialTiles,
  items,
}) => {
  const testimonials = items;

  return (
    <Carousel
      name={name}
      itemsPerSlide={1}
      padItems
      noWrap={false}
      renderItem={(_item, _index, slideIndex) => {
        const tileIndex = Math.abs((slideIndex ?? 0) % testimonialTiles.length);
        return testimonialTiles[tileIndex];
      }}
      items={testimonials}
    />
  );
};

const Carousel = styled(
  CarouselBase as ComponentType<ICarouselProps<ITestimonial>>
)`
  max-width: 1008px;
`;
